var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AwlTable',{staticClass:"finanziamenti-list-table",attrs:{"heading":_vm.tableHeadings,"rows":_vm.tableRows,"striped":""},scopedSlots:_vm._u([{key:"column-key-importo",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(_vm._f("money")(value))+" ")]}},{key:"column-key-tasso",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(value)+"% ")]}},(_vm.editEnabled)?{key:"actions-content",fn:function(ref){
var row = ref.row;
return [_c('ActionEdit',{staticClass:"mr-0 mr-md-2",attrs:{"to":{ name: 'operative-company.data-analysis.finanziamenti.edit', params: { finanziamentoId: row.id } }}}),_c('ActionDelete',{on:{"click":function($event){return _vm.remove(row.id)}}})]}}:null],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }